module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "chapter-title-with-subtitle",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "all-caps CharOverride-6"
  }, [_vm._v("PRELUDE")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter-subtitle"
  }, [_c('span', {
    staticClass: "all-caps"
  }, [_vm._v("FACING WEST")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left"
  }, [_vm._v("SOME SAY THAT to be born into a thing is to be blind to half of it. Oftentimes, the things we seek and discover for ourselves are those we hold most dear. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Any cattleman will tell you that a ranch is a living thing. Not only the livestock that graze the meadowland, but the blood that nourishes the hungry soil, the trees that inhale the wind, and the rain that carves runnels into the hardpan that, in time, grow into rivers. The Diamond D is no different in that respect; some would even say it was the beating heart of Meriwether County, Oregon. As both a stockman and the sheriff of this county, I believe this to be true.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But the events that unfolded in the autumn of 1964 cast a cloud across this land. Not just across my ranch, but the entire valley, though they didn’t bear their terrible fruit until nearly a dozen years later, in the spring of 1976. The incidents still haunt me, though others paid a steeper price than me, some with their lives, or the lives of their loved ones, while some forfeited their sanity, and still others their souls.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("That is where this story begins.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d019cedc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KnifeRiver_5P3.vue
// module id = 78
// module chunks = 0